import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const ContactSection = () => {
  return (
    <section className="bg-white py-24 px-6 md:px-16">
      
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-yellow-100 border border-yellow-200 px-4 py-1.5 rounded-full mb-8">
            <span className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></span>
            <span className="text-yellow-600 text-xs font-semibold uppercase tracking-wider">
              Now Recruiting Partners
            </span>
          </div>
          
          {/* Heading */}
          <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-6">
            Want to <span className="text-yellow-500">Grow</span> <br />
            With Us?
          </h2>

          {/* Description */}
          <p className="max-w-xl mx-auto text-gray-600 text-base md:text-lg mb-10">
            Become a part of <span className="font-semibold text-gray-900">DailyGo</span> and help us build the future of wholesale logistics.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
            
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                to="/JoinUsIndex"
                className="flex items-center gap-3 bg-yellow-500 text-black px-8 py-4 rounded-full font-semibold hover:bg-yellow-400 transition shadow-md"
              >
                Become a Partner
                <ArrowRight className="w-5 h-5" />
              </Link>
            </motion.div>

            <Link
              to="/ContactIndex"
              className="flex items-center gap-2 text-gray-600 hover:text-yellow-500 font-medium text-sm transition"
            >
              Contact Support
              <span className="text-yellow-500">→</span>
            </Link>

          </div>
        </motion.div>
      </div>

    </section>
  );
};

export default ContactSection;